import * as React from "react";
import { Actions, ManageableQuickscanData } from "../types";
import { QuickscanDataContext } from "../context/QuickscanDataContext";
import { Finished } from "./Finished";

export const HeaderNavigation = () => {

    const stepLabels: Array<string> = ['Contactgegevens', 'Informatie over het bedrijf', 'Investeringsbehoefte', 'Afronden'];

    const [quickscanDataState,quickscanDataDispatch] = React.useContext<ManageableQuickscanData>(QuickscanDataContext);

    const setStep = (step: number) => {

        quickscanDataDispatch({
            type: Actions.QuickscanDataTypes.VALIDATE_QUICKSCAN_STEP,
            payload: {
                step: quickscanDataState.currentStep
            }
        })

        quickscanDataDispatch({
            type: Actions.QuickscanDataTypes.SET_QUICKSCAN_STEP,
            payload: {
                step: step
            }
        })

    };

    if(quickscanDataState.finished) {
        return <Finished />
    }

    return <div>
        <h1 className={'c-quickscan__title'}>Quickscan aanvraag</h1>
        <p className={'c-quickscan__intro'}>De quickscan geeft ons in een aantal stappen alle gegevens die nodig zijn om een intake te plannen en eventuele investeringsaanvraag in gang te zetten.</p>
        <div className={'c-quickscan__navigation'}>
            {stepLabels.map((label: string, index: number) => {
                let classNames: Array<string> = ['c-quickscan__navigation-item'];
                if (quickscanDataState.currentStep === index) {
                    classNames.push('c-quickscan__navigation-item--active');
                }
                if(!quickscanDataState.validation.steps[index]) {
                    classNames.push('c-quickscan__navigation-item--invalid');
                }
                if(quickscanDataState.visited[index]) {
                    classNames.push('c-quickscan__navigation-item--visited');
                }
                return <button key={`quickscan__navigation-item${index}`} onClick={() => setStep(index)}
                               className={classNames.join(' ')}><span>{index+1}</span></button>;
            })}
        </div>
        <h3 className={'c-quickscan__step-title c-quickscan__step-title--last'}>{stepLabels[quickscanDataState.currentStep]}</h3>
    </div>

}

